// ⚠️ 本文件由 scripts/gen-version.js 在每次构建前自动生成，请勿手工修改
// 生成时间：2026-11-03 00:59
export const APP_VERSION = '2026-11-03 00:59';
export const APP_BUILD_ID = '796446';
